import * as React from "react";
import {Box, Text} from "@unibuddy/patron";

import useUniversityColor from "../../UniversityProvider/hooks/useUniversityColor";

type DecisionStageTileProps = {
    decisionStageName: string;
    isActive: boolean;
    boxProps?: Record<string, any>;
};

export const DecisionStageTile: React.FC<DecisionStageTileProps> = React.memo(
    ({decisionStageName, isActive, boxProps}: DecisionStageTileProps) => {
        const universityColor = useUniversityColor();

        return (
            <Box
                w="100%"
                h="100px"
                display="flex"
                justifyContent="center"
                alignItems="center"
                paddingX="medium"
                borderWidth={1}
                borderColor={isActive ? universityColor : "#D0D9D9"}
                borderRadius="xxsmall"
                shadow={isActive ? "small" : "none"}
                transition="250ms"
                style={{
                    cursor: "pointer",
                }}
                _hover={{
                    borderWidth: 1,
                    borderColor: universityColor,
                    shadow: "small",
                }}
                {...boxProps}
            >
                <Text weight={isActive ? 700 : null} align="center">
                    {decisionStageName}
                </Text>
            </Box>
        );
    },
);

DecisionStageTile.displayName = "DecisionStageTile";
